"use client";
import { CarouselButton } from "@/components/common";
import { useCarouselButtons } from "@repo/lib/hooks/common";
import { useDotButton } from "@repo/lib/hooks/common";
import { DotButton } from "@repo/components";
import cx from "classnames";
import useEmblaCarousel from "embla-carousel-react";

const Carousel = ({ items, renderItem, locale, slideWidth = "25%" }) => {
  const isEnglish = locale === "en";
  const OPTIONS = {
    duration: 30,
    align: "start",
    slidesToScroll: "auto",
    loop: true,
    direction: isEnglish ? "ltr" : "rtl",
  };

  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = useCarouselButtons(emblaApi);

  const { selectedIndex, scrollSnaps, onDotButtonClick } =
    useDotButton(emblaApi);

  const isCarouselRequired = items?.length > 1;
  function getFlexClass(slideWd) {
    return `md:flex-[0_0_${slideWd}]`;
  }
  return (
    <div className="mx-auto md:max-w-screen-xl">
      <div className="flex items-center justify-center">
        {isCarouselRequired && !prevBtnDisabled && (
          <div className="hidden md:z-10 md:block md:pe-4">
            <CarouselButton
              direction={isEnglish ? "prev" : "next"}
              onClick={onPrevButtonClick}
              disabled={prevBtnDisabled}
              className="bg-[#DDDAD7]"
            />
          </div>
        )}

        <div
          className="w-full overflow-hidden"
          ref={isCarouselRequired ? emblaRef : null}
        >
          <div className="mx-auto flex max-w-[1158px]">
            {items?.map((item, index) => (
              <div
                className={`${
                  slideWidth === "100%"
                    ? "flex-[0_0_100%]"
                    : `${getFlexClass(slideWidth)} flex-[0_0_50%]`
                }`}
                key={index}
              >
                {renderItem(item, index)}
              </div>
            ))}
          </div>
        </div>

        {isCarouselRequired && !nextBtnDisabled && (
          <div className="hidden md:z-10 md:block md:ps-4">
            <CarouselButton
              direction={isEnglish ? "next" : "prev"}
              onClick={onNextButtonClick}
              disabled={nextBtnDisabled}
              className="bg-[#DDDAD7]"
            />
          </div>
        )}
      </div>
      {isCarouselRequired && !prevBtnDisabled && !nextBtnDisabled && (
        <div className="mt-5 flex items-center justify-center gap-2">
          {scrollSnaps.map((_, index) => (
            <DotButton
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={cx("h-[8px] w-[20px]", {
                "bg-[#E5A855]": index === selectedIndex,
                "border-white bg-[#868686]": index !== selectedIndex,
              })}
              aria-label={index}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Carousel;
